<template>
  <div>
    <div v-if="localProvider">
      <!-- <country-chart :provider="localProvider" /> -->
      <section class="sec funder lead mb-0">
        <div class="container container-sm">
          <div class="row expanded">
            <article class="col-xs-12 col-md-9 mb-40 float-md-right funder-details">
              <h1 class="funder-title mb-20"><strong>{{localProvider.name}}-</strong> {{ providerTypesString }}</h1>
              <ul class="row mb-30 actions tags">
                <li v-for="capitalType in capitalTypeList" class="col-xs-6 col-sm-6"><span class="tag-item">{{capitalType}}</span></li>
              </ul>
              <p v-html="description"></p>
              <p v-if="descriptionIsLong" class="mb-0">
                <a v-on:click="longDesc = !longDesc">
                  <span v-if="!longDesc">
                    <i class="text-icon-arrow-right">→</i> Read More
                  </span>
                  <span v-else>
                    <i class="text-icon-arrow-left">←</i> Read Less
                  </span>
                </a>
              </p>
            </article>
            <aside class="col-xs-12 col-md-3 mb-40 funder-info">
              <figure class="funder-logo mb-50">
                <img :src="localProvider.logo" alt="" class="img-circle">
              </figure>
              <hr>
              <p class="funder-website mb-10">
                <a :href="localProvider.url" target="_blank">{{website}}
                </a>
              </p>
              <div class="funder-social">
                <ul class="list-inline">
                   <li v-for="socialMedia in socialMediaList">
                     <a :href="socialMedia.url" v-if="socialMedia.url != ''">
                       <i :class="socialMedia.symbolClass" aria-hidden="true"></i>
                     </a>
                   </li>
                </ul>
               </div>
            </aside>
          </div>
        </div>
      </section>
      <section class="sec sector bg-light lead mb-0">
      <div class="container container-sm">
        <div class="row expanded">
          <sector-chart :provider="localProvider" />

          <aside v-if="fundingRangeString!=''" class="col-xs-12 col-md-4 mb-40 funder-info">
            <h2>FUNDING AMOUNT</h2>
             <p class="h2 font-weight-normal">{{fundingRangeString}}</p>
          </aside>
        </div>
      </div>
      </section>
      <section v-if="currencies.length>0 || languages.length>0" class="sec lead mb-0">
      <div class="container">
        <div class="row my-4">
          <div v-if="languages" class="col-12 col-sm-6">
            <h2>Languages</h2>
            <ul class="bullet-list">
              <li v-for="language in languages">{{ language }}</li>
            </ul>
          </div>
          <div v-if="currencies" class="col-12 col-sm-6">
            <h2>Currencies</h2>
            <ul class="bullet-list">
              <li v-for="currency in currencies">{{ currency }}</li>
            </ul>
          </div>
        </div>
      </div>
      </section>

      <section
        v-if="provider.email || provider.phone_number || office"
        class="sec bg-light lead mb-0">
      <div class="container">
        <div class="row my-4">
          <div class="col-xs-12 col-sm-3">
            <h2>CONTACT</h2>
            <p v-if="provider.email || provider.phone_number">
              <a :href='`mailto:${provider.email}`' v-if="provider.email">{{provider.email}}</a>
              <br> <span v-if="provider.phone_number">{{provider.phone_number}}</span>
            </p>
            <p v-if="office"><strong v-if="firstContactName">{{firstContactName}}</strong>
              <span v-if="office.address_line_1"><br>{{office.address_line_1}}</span>
              <span v-if="office.address_line_2"><br>{{office.address_line_2}}</span>
              <span v-if="office.address_line_3"><br>{{office.address_line_3}}</span>
              <span v-if="office.country.name"><br>{{office.country.name}}</span>
            </p>
          </div>
          <div v-if="office && office.country" class="col-xs-12 col-sm-9">
            <country-map :provider="localProvider" />
          </div>
        </div>
      </div>
      </section>

      <section class="sec lead mb-0">
      <div class="container">
        <p class="my-5 py-lg-5">
          <router-link
              :to="{'name': 'Directory'}"
              class=" btn btn-outline-primary text-defaultcase text-dark back-link"
            >
            <i class="fa fa-angle-left text-primary" aria-hidden="true">
            </i> Back to funder directory
          </router-link>
        </p>
      </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import slugify from "slugify";
import helper from '../helper.js'

// import CountryChart from "../elements/charts/CountryChart.vue";
import SectorChart from "../elements/charts/SectorChart.vue";
import CountryMap from "../elements/charts/CountryMap.vue";

const MAX_DESC_LEN = 450

export default {
  name: "Profile",
  components: {
    // "country-chart": CountryChart,
    "sector-chart": SectorChart,
    "country-map": CountryMap
  },
  data() {
    return {
      msg: "Profile",
      urlSlugName: this.$route.params.providerName,
      longDesc: false,
    };
  },
  computed: {
    ...mapGetters(["results", "providerList", "provider"]),
    localProvider: function() {
      if (this.isProviderInUrl(this.provider, this.urlSlugName)) {
        return this.provider;
      } else {
        return undefined;
      }
    },
    description: function(){
      if (this.localProvider.description == null) return "";
      if (this.longDesc || !this.descriptionIsLong) {
        return helper.formatDesc(this.localProvider.description)
      } else {
        return helper.formatDesc(this.localProvider.description.substring(0, MAX_DESC_LEN) + '...')
      }
    },
    descriptionIsLong: function(){
      return this.localProvider.description.length > MAX_DESC_LEN
    },
    providerTypesString: function() {
      if (this.localProvider.provider_provider_types == null) return "";
      var providerTypes = this.localProvider.provider_provider_types
        .filter(providerType => {
          return providerType.provider_type != null;
        })
        .map(providerType => {
          return providerType.provider_type.name;
        });
      if (providerTypes.length > 1) {
        var last = providerTypes.pop();
        providerTypes = `${providerTypes.join(", ")} & ${last}`;
        return providerTypes;
      } else {
        return providerTypes[0];
      }
    },
    capitalTypeList: function() {
      if (this.localProvider.provider_capital_types == null) return [];
      var capitalTypes = this.localProvider.provider_capital_types
        .filter(capitalType => {
          return capitalType.capital_type != null;
        })
        .map(capitalType => {
          return capitalType.capital_type.name;
        });
      return capitalTypes;
    },
    socialMediaList: function() {
      if (this.localProvider.provider_social_medias == null) return [];
      var nameToSymbolMap = {
        Facebook: "fa fa-facebook",
        Twitter: "fa fa-twitter",
        LinkedIn: "fa fa-linkedin",
        YouTube: "fa fa-youtube-play",
        Instagram: "fa fa-instagram"
      };
      return this.localProvider.provider_social_medias.map(social => ({
        name: social.social_media.name,
        url: social.url,
        symbolClass: nameToSymbolMap[social.social_media.name]
      }));
    },
    fundingRangeString(){
      if (this.localProvider.provider_stats == null) return '';
      var min_inv = this.localProvider.provider_stats
        .find(stat=>stat.stat_id == 1)
      var max_inv = this.localProvider.provider_stats
        .find(stat=>stat.stat_id == 2)
      if (min_inv == undefined && max_inv == undefined) {
        return ''
      } else if ((min_inv == undefined || min_inv.value == 0) && max_inv != undefined) {
        return `< $${this.formatCurrency(max_inv.value)}`
      } else if ((max_inv == undefined || max_inv.value == 0) && min_inv != undefined) {
        return `> $${this.formatCurrency(min_inv.value)}`
      } else {
        return `$${this.formatCurrency(min_inv.value)} - $${this.formatCurrency(max_inv.value)}`
      }
    },
    website(){
      if (this.localProvider.url == null) return;
      var url = this.localProvider.url.replace('https://', '')
      url = url.replace('http://', '')
      var indexOfFirstSlash = url.indexOf('/')
      return url.substring(0, indexOfFirstSlash == -1 ? url.length : indexOfFirstSlash)
    },
    currencies(){
      if (this.localProvider.provider_currencies == null) return null;
      return this.localProvider.provider_currencies
        .map(currency=>`${currency.currency.name}, ${currency.currency.symbol}, (${currency.currency.code})`)
        .filter((currency, i)=>i<5)
    },
    languages(){
      if (this.localProvider.provider_languages == null) return null;
      return this.localProvider.provider_languages
        .map(language=>`${language.language.name}`)
        .filter((currency, i)=>i<5)
    },
    firstContactName(){
      if(this.localProvider.contacts==null||this.localProvider.contacts.length==0) return null
      return this.localProvider.contacts[0].name
    },
    office(){
      if (this.localProvider.offices==null||this.localProvider.offices.legnth==0) return null
      return this.localProvider.offices[0]
    }
  },
  methods: {
    ...mapMutations({
      setProvider: "setProvider"
    }),
    ...mapActions(["fetchProviderById"]),
    formatCurrency(amount){
      var amountDollars = Math.round(amount/100)
      return helper.formatMoney(amountDollars)
    },
    isProviderInUrl(provider, slug) {
      if (provider.hasOwnProperty("id")) {
        return slugify(provider.name, { lower: true }) == slug;
      } else {
        return false;
      }
    },
  },
  created() {
    // first check results to see if we already have provider
    var selectedProvider = this.results.find(provider => {
      return this.isProviderInUrl(provider, this.urlSlugName);
    });
    if (selectedProvider) {
      this.setProvider(selectedProvider);
    }

    // next we index it from providerList and fetch by id
    selectedProvider = this.providerList.find(provider => {
      return this.isProviderInUrl(provider, this.urlSlugName);
    });

    //if we find provider id we send api request else we do so in the providerList Watch once the results are in.
    if (selectedProvider) {
      this.fetchProviderById({ provider_id: selectedProvider.id });
    }
  },
  watch: {
    providerList(newValue, oldValue) {
      var selectedProvider = newValue.find(provider => {
        return this.isProviderInUrl(provider, this.urlSlugName);
      });
      this.fetchProviderById({ provider_id: selectedProvider.id });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue